var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"font-weight-bold mb-1"},[_vm._v("Stopping Early")]),_vm._v(" Don't close the window, you must click \""),_c('b',[_vm._v("Stop")]),_vm._v("\". Shortly after the session is shutdown, the unused time will be returned to your account balance. ")])
}]

export { render, staticRenderFns }